import { useLocation, Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useState, useEffect } from 'react';

import axios from 'axios';

/**
 * 認証トークンをlocalStorageに格納する
 * @param {*} token
 */
export const setToken = (token) => {
  localStorage.setItem('temitope', token); // make up your own token
};

/**
 * 格納されている認証トークンをlocalStorageから取り出す
 * @param {*} token
 * @returns
 */
export const fetchToken = (token) => {
  return localStorage.getItem('temitope');
};

/**
 *
 * @returns
 */
export const fetchSelfUserInfo = () => {
  const json = localStorage.getItem('selfuserinfo');
  return JSON.parse(json);
};

/**
 * 認証トークンがあるかどうか（認証済みかどうか）をチェックする Wrapper Component.
 * @param {*} param0
 * @returns
 */
export function RequireToken({ roles, notAuthorized, children }) {
  const navigate = useNavigate();

  let auth = fetchToken();
  let location = useLocation();

  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    getUserInfo().then((response) => {
      if (response['data']) {
        localStorage.setItem('selfuserinfo', JSON.stringify(response.data));
        setUserInfo(response.data);
      }
    });
  }, []);

  const getUserInfo = () => {
    const headers = {
      accept: 'application/json',
      Authorization: 'Bearer ' + fetchToken(),
    };

    const response = axios
      .get('/api/v1/self/', { headers: headers })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('temitope');
          navigate('/login');
        }
        return error.response.status;
      });

    return response;
  };

  if (!auth) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  // if (!userInfo) {
  //   return <><div>now loading...</div></>
  // }

  // if (roles ==='supser-user' && !userInfo.is_superuser) {
  //   return <><div>unauth</div></>
  // }

  return (
    <>
      {!userInfo ? (
        <>
          <div>now loading...</div>
        </>
      ) : (
        <>
          {roles === 'super-user' && !userInfo.is_superuser ? (
            <>
              {!notAuthorized ? (
                <>
                  <div>unauth</div>
                </>
              ) : (
                <>{notAuthorized}</>
              )}
            </>
          ) : (
            <>{children}</>
          )}
        </>
      )}
    </>
  );
}

// export const signOut = () => {
//     const navigate = useNavigate();

//     localStorage.removeItem("temitope");
//     navigate("/login");
// }
